import { useApprovalContext } from '../../hooks/useApprovalContext';
import ApprovalNote from './ApprovalNote';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalCancelNote() {
  const approval = useApprovalContext();
  if (!approval.data) {
    return null;
  }
  const {
    requester,
    cancelNote,
    cancelNoteTimestamp
  } = approval.data;
  return /*#__PURE__*/_jsx(ApprovalNote, {
    approvalUser: requester,
    note: cancelNote,
    timestamp: cancelNoteTimestamp
  });
}
export default ApprovalCancelNote;